<template>
  <div class="p-6 max-w-lg mx-auto">
    <h2 class="text-xl font-bold mb-3">FreeSWITCH 对讲 Demo</h2>

    <div class="space-y-2 mb-4">
      <input v-model="caller" placeholder="主叫分机号" />
      <input v-model="callee" placeholder="被叫分机号" />
    </div>

    <div class="space-x-2 mb-4">
      <button @click="startTalk" :disabled="talking">开始对讲</button>
      <button @click="stopTalk" :disabled="!talking">结束对讲</button>
    </div>

    <div class="mt-4">
      <div>实时音量: {{ volume }}</div>
      <div class="w-full h-2 bg-gray-300">
        <div
          class="h-2 bg-green-500"
          :style="{ width: volume + '%' }"
        ></div>
      </div>
    </div>

    <audio id="remoteAudio" autoplay playsinline></audio>
  </div>
</template>

<script>
/* global $ */  // 告诉 ESLint $ 是全局变量
export default {
  data() {
    return {
      caller: '1000',
      callee: '1001',
      verto: null,
      callSession: null,
      talking: false,
      muted: false,
      micStream: null,
      volume: 0
    }
  },
  methods: {
    async startTalk() {
      // 初始化 verto
      this.verto = new $.verto({
        login: `1000`,
        passwd: 'JgeHfTArU3lu',
        socketUrl: `wss://freeswitch.waxiaoyu.cn:8082?_=${Date.now()}`,
        tag: 'remoteAudio',
        deviceParams: { useMic: 'any', useSpeak: 'any' }
      }, {
        onWSLogin: () => {
          console.log('✅ FreeSWITCH 已连接')
        },
        onWSClose: () => console.log('❌ 连接关闭'),
        onLogin: () => {
          console.log('🔌 WebSocket connected — waiting for authentication...');
        },
        onError: (err) => {
          // 可能会收到一次 -32000（重连时），但最终会成功
          console.warn('⚠️ Verto error (may be transient):', err);
        },
        onDialogState: (d) => {
          if (d.state === "ringing") {
            console.log("ringing")
            d.answer(); // 自动接听测试
          }
        }
      })

      // 发起呼叫
      this.callSession = this.verto.newCall({
        destination_number: this.callee,
        caller_id_name: this.caller,
        caller_id_number: this.caller,
        useVideo: false
      })
      console.log(this.callSession)

      // 获取麦克风并做音量检测
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true
        }
      })
      this.micStream = stream
      this.startVolumeDetection(stream)
      this.talking = true
    },

    stopTalk() {
      if (this.callSession) this.callSession.hangup()
      if (this.verto) this.verto.logout()
      if (this.micStream) {
        this.micStream.getTracks().forEach(t => t.stop())
      }
      this.talking = false
      this.muted = false
      this.volume = 0
    },

    toggleMute() {
      if (!this.micStream) return
      this.muted = !this.muted
      this.micStream.getAudioTracks().forEach(t => t.enabled = !this.muted)
    },

    startVolumeDetection(stream) {
      const audioCtx = new AudioContext()
      const source = audioCtx.createMediaStreamSource(stream)
      const analyser = audioCtx.createAnalyser()
      analyser.fftSize = 256
      source.connect(analyser)
      const data = new Uint8Array(analyser.frequencyBinCount)

      const detect = () => {
        analyser.getByteFrequencyData(data)
        const avg = data.reduce((a, b) => a + b, 0) / data.length
        this.volume = Math.min(100, Math.round((avg / 255) * 100))
        if (this.talking) requestAnimationFrame(detect)
      }
      detect()
    }
  }
}
</script>

<style>
body {
  font-family: sans-serif;
}
button {
  background: #007bff;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}
button:disabled {
  background: #ccc;
}
input {
  border: 1px solid #ccc;
  padding: 6px;
  margin-right: 4px;
}
</style>
